import { render, staticRenderFns } from "./referralChianTipCard.vue?vue&type=template&id=2a472804&scoped=true"
import script from "./referralChianTipCard.vue?vue&type=script&lang=js"
export * from "./referralChianTipCard.vue?vue&type=script&lang=js"
import style0 from "./referralChianTipCard.vue?vue&type=style&index=0&id=2a472804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a472804",
  null
  
)

export default component.exports